import { NavigationGuard } from 'vue-router'
import { useLinkedinScanStore } from '@/store/pinia/linkedinScanStore'
import { useModalStore, Modal } from '@/store/pinia/modalStore'
import useUser from '@/composables/useUser'

export const hasScanParameters: NavigationGuard = (to, from, next) => {
  const linkedinScanStore = useLinkedinScanStore()
  if (linkedinScanStore.jobDescriptionsId.length && linkedinScanStore.linkedinProfileUrl) next()
  else next({ name: 'linkedin-scan' })
}

export const userCanAccessNetworkingMessageGenerator: NavigationGuard = (
  _to,
  _from,
  next
) => {
  if (useUser().user.value.allowLinkedInScan) {
    return next()
  }
  useModalStore().openModal(Modal.NetworkMessageGeneratorUpgradeModal)
}
